import type { PrhHouseDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/prh';
import type { TableInformation } from '../../../../config/flavourConfig';
import { getCurrencyString } from '../../../../utils/currencyUtil';

const getPrhHouseInsuranceSumsCoverableDetailsConfig = (
    houseCoverable: PrhHouseDTO,
    getHippoText: (resourceKey: string) => string
): TableInformation => {
    return {
        title: 'Forsikringssummer',
        rowsInformation: [
            {
                name: getHippoText('DSS- INSURANCE-SUMS-FIRST-RISK'),
                fieldValue:
                    houseCoverable.firstRiskSum !== undefined
                        ? getCurrencyString(houseCoverable.firstRiskSum, ' kr.')
                        : undefined,
                hidden: houseCoverable.firstRiskSum === undefined
            }
        ]
    };
};

export { getPrhHouseInsuranceSumsCoverableDetailsConfig };
